import EventConstants from '../constants/EventConstants';
import AppService from './AppService';

export default {
  openCamera: (options = {}) => {
    return new Promise((resolve, reject) => {
      const unSubscribe =
        window &&
        window.eventemitter.subscribe(EventConstants.eventNames.WEB_IMAGE_DATA, imageData => {
          unSubscribe && unSubscribe();
          AppService.closeWebCamera();
          resolve(imageData);
        });
      const unSubscribeError =
        window &&
        window.eventemitter.subscribe(EventConstants.eventNames.WEB_IMAGE_ERROR, error => {
          unSubscribeError && unSubscribeError();
          AppService.closeWebCamera();
          reject(error);
        });
      AppService.openWebCamera({ unSubscribeEvent: unSubscribe, ...options });
    });
  },
  openFile: (options = {}) => {
    return new Promise((resolve, reject) => {
      const unSubscribe =
        window &&
        window.eventemitter.subscribe(EventConstants.eventNames.WEB_FILE_SUCCESS, file => {
          unSubscribe && unSubscribe();
          resolve(file);
        });
      const unSubscribeError =
        window &&
        window.eventemitter.subscribe(EventConstants.eventNames.WEB_FILE_ERROR, error => {
          unSubscribeError && unSubscribeError();
          reject(error);
        });
      AppService.openWebFile(options);
    });
  },
};
